import React, { useState, useEffect  } from 'react'
import FormField from './FormField'
const SetEmail = ({passedValue,setValue}) => {
    const [email, setEmail] = useState(passedValue || '')
    const [errorMessage, setErrorMessage] = useState('')
    useEffect(() => {
        setEmail(passedValue)        
    }, [passedValue])

    const emailIsValid = () => {
        if(email === '') {
            setErrorMessage('Please provide an email address.')
            setValue(null)
            return false
        } else if(/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email) === false) {
            setErrorMessage('The email address you entered is not formatted correctly.')
            setValue(null)
            return false
        }
        setErrorMessage('')
        setValue(email)
        return true
    }

    return (
        <div className="form-group">
            <label htmlFor="email">Email address</label>
            <FormField type="text" id="email" value={email} errorMessage={errorMessage} handleChange={setEmail} validateFunction={emailIsValid}/>
        </div>

    )
}
export default SetEmail


